import React, { createContext } from 'react';

export const MapContext = createContext({
  // mapboxgl.Map instance
  map: null
});

export const withMap = (Component) => (props) =>
  (
    <MapContext.Consumer>
      {(mapProps) => <Component {...mapProps} {...props} />}
    </MapContext.Consumer>
  );

export default MapContext;
